import { Repository } from '../../../core/context/repository';
import { type ThreatVector } from './entity';

export class ThreatVectors extends Repository<ThreatVector> {
    getAllByThreatPathId(threatPathId: string): ThreatVector[] {
        return this.items.filter(
            (threatVector) => threatVector.threatPathId === threatPathId,
        );
    }
}
